<template>
  <div id="app" class="srm-layout">
    <SrmHeader 
      :sidebar-collapsed="isSidebarCollapsed" 
      :is-mobile="isMobile"
      @toggle-sidebar="toggleSidebar"
    />
    <div class="srm-body">
      <SrmSidebar 
        :collapsed="isSidebarCollapsed" 
        :is-mobile="isMobile"
        :active-key="currentPage"
        @toggle="toggleSidebar"
        @change="handlePageChange"
      />
      
      <main class="srm-main" :class="{ 'is-collapsed': isSidebarCollapsed, 'is-mobile': isMobile }">
        <div class="page-scroll-area">
          <component :is="currentPage" />
        </div>
      </main>
    </div>

    <div 
      v-if="isMobile && !isSidebarCollapsed" 
      class="sidebar-mask" 
      @click="toggleSidebar"
    ></div>
  </div>
</template>

<script>
import SrmHeader from './components/SrmHeader.vue'
import SrmSidebar from './components/SrmSidebar.vue'

// 引入7个独立页面组件（运行时编译安全）
import SrmDashboard from './pages/SrmDashboard.vue'
import SrmSupplierAccess from './pages/SrmSupplierAccess.vue'
import SrmSourcing from './pages/SrmSourcing.vue'
import SrmContract from './pages/SrmContract.vue'
import SrmOrder from './pages/SrmOrder.vue'
import SrmPerformance from './pages/SrmPerformance.vue'
import SrmCollaboration from './pages/SrmCollaboration.vue'

export default {
  name: 'SRM',
  components: {
    SrmHeader,
    SrmSidebar,
    SrmDashboard,
    SrmSupplierAccess,
    SrmSourcing,
    SrmContract,
    SrmOrder,
    SrmPerformance,
    SrmCollaboration
  },
  data() {
    return {
      currentPage: 'SrmDashboard',
      isSidebarCollapsed: false,
      isMobile: false
    }
  },
  mounted() {
    this.checkScreen()
    window.addEventListener('resize', this.checkScreen)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreen)
  },
  methods: {
    checkScreen() {
      const width = window.innerWidth
      this.isMobile = width <= 1024
      this.isSidebarCollapsed = width <= 1024
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
    },
    handlePageChange(page) {
      this.currentPage = page
      if (this.isMobile) {
        this.isSidebarCollapsed = true
      }
    }
  }
}
</script>

<style lang="scss">
* { margin: 0; padding: 0; box-sizing: border-box; }

html, body, #app {
  height: 100%;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  background: #011039;
  color: #fff;
  overflow: hidden;
}

.srm-layout {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: #011039;
  overflow: hidden;
}

.srm-body {
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
}

.srm-main {
  flex: 1;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;

  &.is-mobile {
    width: 100%;
  }
}

.page-scroll-area {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 212, 255, 0.05);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 212, 255, 0.25);
    border-radius: 3px;
    &:hover {
      background: rgba(0, 212, 255, 0.4);
    }
  }
}

.sidebar-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 998;
  backdrop-filter: blur(2px);
}
</style>